import React from 'react'
import PageLayout from '../../PageLayout'
import { EPageTitle, ETable } from '../../libs/ui'
import { Badge, Loader, Skeleton } from '@mantine/core'
import { handleCheckDateRange, handleCheckEndDateRange, handleSortByOrderDate } from '../../utils/utility'
import moment from 'moment'
import { CiViewTable } from 'react-icons/ci'
import useSchoolSurvey from './hook/useSchoolSurvey'
import SchoolSurveyQuestions from './components/SchoolSurveyQuestions'

const SchoolSurvey = () => {
    const {
      isLoading,
      data,
      districts,
      surveyQuestionEnable,
      setSurveyQuestionEnable,
      surveyDetails,
      handleSave,
      handleUpdateAnswer,
      questionGroups,
      getSurveyById,
      detailLoading,
      loadingSurveyId,
    }: any = useSchoolSurvey();
  return (
    <PageLayout>
      {!surveyQuestionEnable ? (
        <>
          <EPageTitle title="Survey" />
          <div className="mt-7">
            {isLoading ? (
              <Skeleton height={300}>loading</Skeleton>
            ) : (
              <ETable>
                <thead>
                  <tr>
                    <th>Survey Title</th>
                    <th>Description</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Status</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {handleSortByOrderDate({
                    appointments: data,
                    orderByDateKey: "survey_Start_Date",
                  }).map((each) => (
                    <tr>
                      <td>{each?.survey_Title ?? "-"}</td>
                      <td>
                        {each?.survey_Description
                          ? each?.survey_Description
                          : "-"}
                      </td>
                      <td>
                        {each?.survey_Start_Date
                          ? moment(each?.survey_Start_Date).format("DD-MM-YYYY")
                          : "--/--/----"}
                      </td>
                      <td>
                        {each?.survey_End_Date
                          ? moment(each?.survey_End_Date).format("DD-MM-YYYY")
                          : "--/--/----"}
                      </td>
                      {handleCheckDateRange(each?.survey_Start_Date) ? (
                        <td>
                          {/* incoming */}
                          <Badge color="blue">Upcoming</Badge>
                        </td>
                      ) : handleCheckEndDateRange(each?.survey_End_Date) ? (
                        <td>
                          {/* Expire */}
                          <Badge color="red">Expired</Badge>
                        </td>
                      ) : (
                        <td>
                          {/* ONgoing */}
                          <Badge color="orange">On going</Badge>
                        </td>
                      )}
                      <td>
                        <div
                          className="flex mt-2 ml-1 cursor-pointer items-center gap-1"
                          onClick={() => {
                            if (!detailLoading) getSurveyById(each?.survey_Id);
                          }}
                        >
                          {loadingSurveyId === each?.survey_Id ? (
                            <Loader size="xs" />
                          ) : (
                            <>
                              <CiViewTable size={14} />
                              <p className=" text-blue-400 text-sm">Details</p>
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </ETable>
            )}
          </div>
        </>
      ) : (
        <div>
          <SchoolSurveyQuestions
            surveyDetails={surveyDetails}
            districts={districts}
            setSurveyQuestionEnable={setSurveyQuestionEnable}
            handleSave={handleSave}
            handleUpdateAnswer={handleUpdateAnswer}
            questionGroups={questionGroups}
          />
        </div>
      )}
    </PageLayout>
  );
}

export default SchoolSurvey